<template>
<section>
  <van-checkbox-group v-model="checkedOptionIds" @change="onChange">
    <van-checkbox
      v-for="(opt, optIndex) in checkItem.choiceOpts"
      :key="optIndex"
      :name="opt.id"
      :disabled="checkedOptionIds.indexOf(ALL_NO) > -1"
      shape="square"
    >{{opt.optionContent}}</van-checkbox>
    <van-checkbox :name="ALL_NO" shape="square">以上条件都不满足</van-checkbox>
  </van-checkbox-group>
</section>
</template>

<script>
import BaseTaskResultOptionComponent from '../BaseTaskResultOptionComponent'

const ALL_NO = 'ALL_NO'

export default {
  name: 'TaskResultCheckbox',
  extends: BaseTaskResultOptionComponent,
  OPTION_TYPE: 2,
  getSelected: checkItem => {
    let opts = checkItem.choiceOpts.filter(opt => opt.value === 1).map(opt => opt.optionContent)

    if (opts.length === 0) {
      opts.push('所有条件都不满足')
    }

    return opts
  },
  data () {
    let checkItem = this.checkItem
    let checkedOptionIds = checkItem.choiceOpts.filter(opt => opt.value === 1).map(opt => opt.id)

    if (checkItem.isCompleted && checkedOptionIds.length === 0) {
      checkedOptionIds.push(ALL_NO)
    }

    return {
      checkedOptionIds
    }
  },
  computed: {
    ALL_NO: () => ALL_NO
  },
  methods: {
    onChange (checkedOptionIds) {
      const ALL_NO = this.ALL_NO

      if (checkedOptionIds.length > 1 && checkedOptionIds.indexOf(ALL_NO) > -1) {
        return checkedOptionIds.splice(0, checkedOptionIds.length, ALL_NO)
      }

      let checkItem = this.checkItem
      let checkItemOptions = []

      checkItem.choiceOpts.forEach(opt => {
        if (checkedOptionIds.indexOf(opt.id) > -1) {
          opt.value = 1
          checkItemOptions.push(opt)
        } else {
          opt.value = 0
        }
      })

      checkItem.isCompleted = checkedOptionIds.length > 0
      checkItem.score = checkItemOptions.reduce((count, opt) => count + opt.score, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.van-checkbox {
  /deep/ {
    .van-checkbox__icon {
      padding-top: 1px;

      .van-icon {
        font-size: 0.65em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/TaskResult/Checkbox/index.vue